<template>
	<div
		class="side-nav"
		:class="{ fixedwidth: menuStatus, trans: !menuStatus }"
		@mouseleave="setOptions()"
		@mouseenter="showOptions()"
	>
		<div class="side-close pointer" v-if="menuStatus" @click="closeSideBar">
			<img src="../../assets/icons/sidenav/MenuClose.svg" alt />
		</div>
		<div class="side-menu-main">
			<ul class="list-unstyled">
				<li
					v-if="roles.includes('GET_TOPIC')"
					@click="goToHome()"
					class="d-flex align-items-center pointer"
				>
					<img
						v-if="checkHome"
						src="../../assets/icons/sidenav/Homered.svg"
						alt
					/>
					<img v-else src="../../assets/icons/sidenav/Homegray.svg" alt />
					<span
						id="Home"
						:class="checkHome ? 'activenavclass' : 'inactivenavclass'"
						>Home</span
					>
				</li>

				<li
					v-if="
						roles.includes('VIEW_ADMIN') ||
							roles.includes('GET_EVALUATOR') ||
							roles.includes('GET_ROLE')
					"
					@click="showPermissions = !showPermissions"
					class="d-flex align-items-center pointer"
					style="justify-content: space-between; width:115%"
					:style="showPermissions ? 'margin-bottom: 12px !important;' : ''"
				>
					<div style="width : 90%;">
						<img
							v-if="checkPermissions"
							src="../../assets/icons/sidenav/Accesscontrolred.svg"
							alt
						/>
						<img
							v-else
							src="../../assets/icons/sidenav/Accesscontrolgray.svg"
							alt
						/>
						<span
							id="AccessPanel"
							:class="checkPermissions ? 'activenavclass' : 'inactivenavclass'"
							>Permissions</span
						>
					</div>
					<div style="width : 25%;">
						<img
							v-if="checkPermissions && showPermissions"
							src="../../assets/icons/sidenav/red-uparrow.svg"
							alt
						/>
						<img
							v-else-if="!checkPermissions && showPermissions"
							src="../../assets/assess-main-upArrow.svg"
							alt
						/>
						<img
							v-else-if="checkPermissions && !showPermissions"
							src="../../assets/icons/sidenav/red-downarrow.svg"
							alt
						/>
						<img v-else src="../../assets/icons/sidenav/Vector.svg" alt />
					</div>
				</li>
				<div
					class="d-flex ml-5 innerOptions"
					style="flex-direction: column;"
					v-if="showPermissions"
				>
					<div
						v-if="roles.includes('VIEW_ADMIN')"
						@click="goToAccessPanel()"
						class="d-flex align-items-center"
					>
						<span
							id="Users"
							:class="checkUsers ? 'activenavclass' : 'inactivenavclass'"
							>Users</span
						>
					</div>

					<div
						v-if="roles.includes('GET_ROLE')"
						@click="goToRoles()"
						class="d-flex align-items-center mt-2"
					>
						<span
							id="Roles"
							:class="checkRoles ? 'activenavclass' : 'inactivenavclass'"
							>Roles</span
						>
					</div>
					<div
						v-if="roles.includes('GET_EVALUATOR')"
						@click="gotoEval()"
						class="d-flex align-items-center mt-2"
					>
						<span
							id="Evaluator"
							:class="checkEval ? 'activenavclass' : 'inactivenavclass'"
							>Evaluators</span
						>
					</div>
				</div>

				<li
					v-if="
						roles.includes('GET_QUESTION_BANK') ||
							roles.includes('GET_CODING_TEST')
					"
					@click="showQuestionBank = !showQuestionBank"
					class="d-flex align-items-center pointer"
					style="justify-content: space-between; width:115%"
					:style="
						showPermissions && showQuestionBank
							? 'margin-bottom: 12px !important; margin-top: 12px !important;'
							: showQuestionBank
							? 'margin-bottom: 12px !important;'
							: showPermissions
							? 'margin-top: 12px !important;'
							: ''
					"
				>
					<div style="width : 90%;">
						<img
							v-if="checkQuestionBankAll"
							src="../../assets/icons/sidenav/questionbankred.svg"
							alt
						/>
						<img
							v-else
							src="../../assets/icons/sidenav/questionbankgray.svg"
							alt
						/>
						<span
							id="QuestionBank"
							class
							:class="
								checkQuestionBankAll ? 'activenavclass' : 'inactivenavclass'
							"
							>Question Bank</span
						>
					</div>
					<div style="width : 25%;">
						<img
							v-if="checkQuestionBankAll && showQuestionBank"
							src="../../assets/icons/sidenav/red-uparrow.svg"
							alt
						/>
						<img
							v-else-if="!checkQuestionBankAll && showQuestionBank"
							src="../../assets/assess-main-upArrow.svg"
							alt
						/>
						<img
							v-else-if="checkQuestionBankAll && !showQuestionBank"
							src="../../assets/icons/sidenav/red-downarrow.svg"
							alt
						/>
						<img v-else src="../../assets/icons/sidenav/Vector.svg" alt />
					</div>
				</li>
				<div
					class="d-flex ml-5 innerOptions"
					style="flex-direction: column;"
					v-if="showQuestionBank"
				>
					<div
						v-if="roles.includes('GET_QUESTION_BANK')"
						@click="goToQuestionBank()"
						class="d-flex align-items-center"
					>
						<span
							id="Users"
							class="optionWidth"
							:class="checkQuestionBank ? 'activenavclass' : 'inactivenavclass'"
							>Question Bank</span
						>
					</div>

					<div
						v-if="roles.includes('GET_CODING_TEST')"
						@click="gotoCode()"
						class="d-flex align-items-center mt-2"
					>
						<span
							class="optionWidth"
							id="CodingTest"
							:class="checkCodeTest ? 'activenavclass' : 'inactivenavclass'"
							>Coding Test</span
						>
					</div>
					<div
						v-if="roles.includes('GET_QUESTION_BANK')"
						@click="gotoCommunication()"
						class="d-flex align-items-center mt-2"
					>
						<span
							class="optionWidth"
							id="CommunicationTest"
							:class="checkCommunication ? 'activenavclass' : 'inactivenavclass'"
							>Communication</span
						>
					</div>
				</div>

				<li
					v-if="roles.includes('GET_AUTOGENERATE')"
					@click="goToAutogenerate()"
					class="d-flex align-items-center pointer"
					:style="showQuestionBank ? 'margin-top: 12px !important;' : ''"
				>
					<img
						v-if="checkAutoGen"
						src="../../assets/icons/sidenav/Autogenerationtestred.svg"
						alt
					/>
					<img
						v-else
						src="../../assets/icons/sidenav/Autogenerationtestgray.svg"
						alt
					/>
					<span
						id="autogenerate"
						:class="checkAutoGen ? 'activenavclass' : 'inactivenavclass'"
						>AutoGenerate Test</span
					>
				</li>
				<li
					v-if="roles.includes('GET_TRANSACTION')"
					@click="goToTransaction()"
					class="d-flex align-items-center pointer"
				>
					<img
						v-if="checkTransaction"
						src="../../assets/icons/sidenav/transaction-active..svg"
						alt
					/>
					<img
						v-else
						src="../../assets/icons/sidenav/transaction-inactive.svg"
						alt
					/>
					<span
						id="Transaction"
						:class="checkTransaction ? 'activenavclass' : 'inactivenavclass'"
						>Transaction</span
					>
				</li>
				<li
					v-if="roles.includes('GET_GROUP') || roles.includes('GET_INDIVIDUAL')"
					@click="goToGroup()"
					class="d-flex align-items-center pointer"
				>
					<img
						v-if="checkGroup"
						src="../../assets/icons/sidenav/Groupred.svg"
						alt
					/>
					<img v-else src="../../assets/icons/sidenav/Groupgray.svg" alt />
					<span
						id="autogenerate"
						:class="checkGroup ? 'activenavclass' : 'inactivenavclass'"
						>Individual / Group</span
					>
				</li>
				<li
					v-if="
						roles.includes('GET_PROCTORING') ||
							roles.includes('GET_EVALUATOR_TEST')
					"
					class="d-flex align-items-center pointer"
					@click="gotoproctoring()"
				>
					<img
						v-if="checkProctor"
						src="../../assets/icons/sidenav/Evaluate Tests red.svg"
						alt
					/>
					<img
						v-else
						src="../../assets/icons/sidenav/Evaluate Tests gry.svg"
						alt
					/>
					<span
						v-if="roles.includes('GET_EVALUATOR_TEST')"
						id="Proctoring"
						:class="checkProctor ? 'activenavclass' : 'inactivenavclass'"
						>Evaluate Tests</span
					>
					<span
						v-else
						id="Proctoring"
						:class="checkProctor ? 'activenavclass' : 'inactivenavclass'"
						>Proctoring</span
					>
				</li>
				<li
					v-if="roles.includes('GET_REPORTS')"
					class="d-flex align-items-center pointer"
					@click="gotoReports()"
				>
					<img
						v-if="checkReports"
						src="../../assets/icons/sidenav/Reports-Assessment.svg"
						alt
					/>
					<img
						v-else
						src="../../assets/icons/sidenav/Reports-Assessmentgry.svg"
						alt
					/>
					<span
						id="Reports"
						:class="checkReports ? 'activenavclass' : 'inactivenavclass'"
						>Reports</span
					>
				</li>
				<li
					@click="showSandboxes = !showSandboxes"
					class="d-flex align-items-center pointer"
					style="justify-content: space-between; width:115%; margin-bottom: 12px !important;"
				>
					<div style="width : 90%;">
						<img
							v-if="checkSandboxes || adminConsole"
							src="../../assets/icons/sidenav/questionbankred.svg"
							alt
						/>
						<img
							v-else
							src="../../assets/icons/sidenav/questionbankgray.svg"
							alt
						/>
						<span
							id="QuestionBank"
							class
							:class="
								checkSandboxes || adminConsole
									? 'activenavclass'
									: 'inactivenavclass'
							"
							>Sandboxes</span
						>
					</div>
					<div style="width : 25%;">
						<img
							v-if="(adminConsole || checkSandboxes) && showSandboxes"
							src="../../assets/icons/sidenav/red-uparrow.svg"
							alt
						/>
						<img
							v-else-if="(!adminConsole || !checkSandboxes) && showSandboxes"
							src="../../assets/assess-main-upArrow.svg"
							alt
						/>
						<img
							v-else-if="(adminConsole || checkSandboxes) && !showSandboxes"
							src="../../assets/icons/sidenav/red-downarrow.svg"
							alt
						/>
						<img v-else src="../../assets/icons/sidenav/Vector.svg" alt />
					</div>
				</li>
				<div
					class="d-flex ml-5 innerOptions"
					style="flex-direction: column;"
					v-if="showSandboxes"
				>
					<div @click="goToSandboxes()" class="d-flex align-items-center">
						<span
							id="Users"
							class="optionWidth"
							:class="checkSandboxes ? 'activenavclass' : 'inactivenavclass'"
							>My Projects</span
						>
					</div>

					<div
						class="d-flex align-items-center mt-2"
						@click="
							$router.push({
								name: 'adminconsole',
								query: {
									type: 'individual',
								},
							})
						"
					>
						<span
							class="optionWidth"
							id="CodingTest"
							:class="adminConsole ? 'activenavclass' : 'inactivenavclass'"
							>Admin Console</span
						>
					</div>
				</div>
			</ul>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	name: "SideBar",
	data() {
		return {
			mini: false,
			manualClose: false,
			magic: "gridicon",
			showPermissions: false,
			showQuestionBank: false,
			showSandboxes: false,
		};
	},
	watch: {
		menuStatus(value) {
			if (!value) {
				this.showPermissions = false;
				this.showQuestionBank = false;
				this.showSandboxes = false;
			}
		},
	},
	computed: {
		...mapGetters(["roles"]),
		...mapGetters("userVUEX", {
			menuStatus: "getMenuStatus",
		}),

		// HELPER FUNCTIONS FOR ROUTES

		// CHECK HOME
		checkHome() {
			const paths = [
				"Home",
				"Tests",
				"QPBuilder",
				"ShareWithPeople",
				"Configure",
				"ParticularTestConfiguration",
				"ShareWithPeopleTest",
				"ConfigureTest",
				"ParticularTestConfigurationTest",
				"EditConfiguration",
				"EditConfigurationTest",
				"ViewConfiguration",
				"ViewConfigurationTest",
				"Archivetest",
			];
			return paths.includes(this.$route.name);
		},

		// CHECK ACCESS CONTROL
		checkPermissions() {
			const paths = [
				"AccessControl",
				"EvaluatorList",
				"AddEvaluator",
				"EditEvaluator",
			];
			return paths.includes(this.$route.name);
		},
		checkUsers() {
			console.log(this.$route);
			return (
				this.$route.fullPath == "/permission/access?status=users" ||
				this.$route.fullPath == "/permission/access"
			);
		},
		checkRoles() {
			return this.$route.fullPath == "/permission/access?status=roles";
		},
		// CHECK QUESTION BANK
		checkQuestionBank() {
			const paths = ["questionbank"];
			return paths.includes(this.$route.name);
		},
		checkQuestionBankAll() {
			const paths = [
				"questionbank",
				"QPcodingTest",
				"BuildingCodeTest",
				"PreviewCodeTest",
				"EditCodingTest",
				"tryCode",
			];
			return paths.includes(this.$route.name);
		},
		// CHECK AUTOGENERATE
		checkAutoGen() {
			const paths = [
				"AutogenerateTest",
				"AutogenerateSection",
				"AutoQPBuilder",
				"ShareWithPeopleAutoQPBuilder",
				"ConfigureAutoQPBuilder",
				"ParticularTestConfigurationAutoQPBuilder",
				"ShareWithPeopleAutogenerate",
				"ConfigureAutogenerate",
				"ParticularTestConfigurationAutogenerate",
				"EditConfigurationAutogenerate",
				"EditConfigurationAutoQPBuilder",
				"ViewConfigurationAutogenerate",
				"ViewConfigurationAutoQPBuilder",
			];
			return paths.includes(this.$route.name);
		},

		// CHECK TRANSACTION
		checkTransaction() {
			const paths = ["Transaction"];
			return paths.includes(this.$route.name);
		},

		// CHECK GROUP
		checkGroup() {
			const paths = ["Group"];
			return paths.includes(this.$route.name);
		},

		// CHECK PROCTORING
		checkProctor() {
			const paths = [
				"ProctoringDashboard",
				"ViewProctorTestScreen",
				"ViewCandidateProctorScreen",
				"candidateproctor",
				"evaluatetest",
			];
			const routeName = this.$route.name;
			const fromRouteQuery = this.$route.query?.fromRoute;

			return (
				paths.includes(routeName) &&
				(routeName !== "evaluatetest" || fromRouteQuery !== "sandbox")
			);
		},

		//CHECK REPORTS
		checkReports() {
			const paths = [
				"OverallAssessment",
				"TopicReport",
				"IndividualTest",
				"CandidatePerformance",
			];
			return paths.includes(this.$route.name);
		},

		// CHECK EVALUATOR
		checkEval() {
			const paths = ["EvaluatorList", "AddEvaluator", "EditEvaluator"];
			return paths.includes(this.$route.name);
		},

		checkCodeTest() {
			const paths = [
				"QPcodingTest",
				"BuildingCodeTest",
				"PreviewCodeTest",
				"EditCodingTest",
				"tryCode",
			];
			return paths.includes(this.$route.name);
		},
		checkCommunication(){
			const paths = [
				"communicationTestQB",
			];
			return paths.includes(this.$route.name);
		},
		checkSandboxes() {
			const paths = ["myprojects","createprojects"];
			return paths.includes(this.$route.name);
		},
		adminConsole() {
			const paths = ["adminconsole", "evaluatetest"];
			const routeName = this.$route.name;
			const fromRouteQuery = this.$route.query?.fromRoute;

			return (
				paths.includes(routeName) &&
				(routeName !== "evaluatetest" || fromRouteQuery === "sandbox")
			);
		},
	},

	methods: {
		goToSandboxes() {
			this.$router.push({
				name: "myprojects",
			});
		},
		setOptions() {
			if (!this.menuStatus) {
				this.showPermissions = false;
				this.showQuestionBank = false;
				this.showSandboxes = false;
			}
		},
		showOptions() {
			if (this.checkPermissions) {
				this.showPermissions = true;
			}
			if (this.checkQuestionBankAll) {
				this.showQuestionBank = true;
			}
		},
		gotomaindash() {
			this.$router.push({ name: "maindashboard" });
		},
		gotoproctoring() {
			this.$router.push({ path: "/proctoring" });
		},
		gotoReports() {
			this.$router.push({ path: "/reports" });
		},
		goToHome() {
			this.$router.push({ path: "/" });
		},
		goToQuestionBank() {
			this.$router.push({ path: "/questionbank" });
		},
		goToAccessPanel() {
			this.$router.push({ path: "/permission" });
		},
		goToRoles() {
			this.$router.push({ path: "/permission", query: { status: "roles" } });
		},
		gotoEval() {
			this.$router.push({ path: "/permission/evaluator/dashboard" });
		},
		gotoCode() {
			this.$router.push({ path: "/questionbank/codingtestqp" });
		},
		gotoCommunication() {
			this.$router.push({ name: "communicationTestQB" });
		},
		goToAutogenerate() {
			this.$router.push({ path: "/autogenerate" });
		},
		gotoEvalrole() {
			this.$router.push({ path: "/eval" });
		},
		goToTransaction() {
			this.$router.push({ path: "/transaction" });
		},
		goToGroup() {
			this.$router.push({ path: "/groups" });
		},
		gotopreview() {
			this.$router.push({ path: "preview" });
		},
		showMod() {
			this.mini = !this.mini;
		},
		gotoresume() {
			this.$router.push({ path: "create" });
		},
		gotochangetemp() {
			this.$router.push({ path: "choose-template" });
		},
		gotocoverletter() {
			this.$router.push({ path: "coverletter" });
		},
		printWindow: function() {
			window.print();
		},
		toggleSidebar() {
			document.getElementById("mySidebar").style.width = "250px";
		},
		closeSideBar() {
			this.$store.commit("userVUEX/setMenuStatus", false);
		},
	},
};
</script>

<style>
.optionWidth {
	min-width: 101px;
}
.innerOptions {
	font-weight: 500;
	font-size: 14px;
	cursor: pointer;
}
.fixedwidth {
	width: 200px !important;
}
.trans {
	transition: width 1s;
}
.side-close {
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	width: 30px;
	height: 30px;
	border-radius: 14px;
	left: 90%;
	top: 40%;
	background: #ffffff;
	z-index: 10;
	box-shadow: 0px 2px 11px rgba(0, 0, 0, 0.25);
}
.activenavclass {
	color: #ad1927 !important;
}
.inactivenavclass {
	color: #adaaaa !important;
}
</style>
